import { render, staticRenderFns } from "./Delivered.vue?vue&type=template&id=c5cbbdaa&"
import script from "./Delivered.vue?vue&type=script&lang=js&"
export * from "./Delivered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports